import { locale } from '../services/i18n';

export default (format) => (unixTime) => (new Date(unixTime))
  .toLocaleDateString(locale(), format);
